/* eslint no-console: "off" */
import { mapState, mapGetters, mapMutations } from 'vuex';

const DigitalParametersMixin = {
  methods: {
    ...mapMutations('common', [
      'storeClickid',
      'updateRefUrl',
      'facebookReferral',
      'storeBanner',
      'updateCampaignId',
      'updatePublisherId',
    ]),
    storeParametersToBrowserStorage() {
      const oldParams = JSON.parse(sessionStorage.getItem('params') || JSON.stringify(''));
      const urlParams = {
        clickid: this.getClickId || (oldParams ? oldParams.clickid : ''),
        fb_ref: this.fbReferral || (oldParams ? oldParams.fb_ref : ''),
        banner: this.banner || (oldParams ? oldParams.banner : ''),
        refUrl: this.getRefUrl || (oldParams ? oldParams.refUrl : ''),
        campaignId: this.getCampaignId || (oldParams ? oldParams.campaignId : ''),
        publisherId: this.getPublisherId || (oldParams ? oldParams.publisherId : ''),
      };
      sessionStorage.setItem('params', JSON.stringify(urlParams));
    },
    retrieveParametersFromBrowserStorage() {
      const params = JSON.parse(sessionStorage.getItem('params') || JSON.stringify(''));
      if (params) {
        // eslint-disable-next-line
        const clickid = params.clickid;
        this.storeClickid({ clickid });
        // eslint-disable-next-line
        const refUrl = params.refUrl;
        this.updateRefUrl({ refUrl });
        // eslint-disable-next-line
        const banner = params.banner;
        this.storeBanner({ value: banner });
        // eslint-disable-next-line
        const fbRef = params.fb_ref;
        this.facebookReferral({ fbRef });
        // eslint-disable-next-line
        const campaignId = params.campaignId;
        this.updateCampaignId({ campaignId });
        // eslint-disable-next-line
        const publisherId = params.publisherId;
        this.updatePublisherId({ publisherId });
      }
      sessionStorage.setItem('params', '');
    },
  },
  computed: {
    ...mapState('common', [
      'fbReferral',
      'banner',
    ]),
    ...mapGetters('common', [
      'getClickId',
      'getRefUrl',
      'getCampaignId',
      'getPublisherId',
    ]),
  },
};

export default DigitalParametersMixin;



// WEBPACK FOOTER //
// ./src/common/mixins/digital/digitalHelper.js